import { includes, orderBy, template } from 'lodash'
import React, { useContext, useState } from 'react'
import i18n from 'simple-react-i18n'
import { NewTable, WrapperCardContent } from '../../../../../components/datatable/NewTable'
import { NoDataPanel } from '../../../../../components/card/NoDataCard'
import ConfirmModal from '../../../../../components/modal/ConfirmModal'
import useBoolean from '../../../../../utils/customHook/useBoolean'
import useCampaignObjectives from '../../../../../utils/customHook/useCampaignObjectives'
import { hasValue } from '../../../../../utils/NumberUtil'
import { removeObjectivesFromExceptions, removeObjectivesFromPlannings } from '../../../../utils/CampaignUtils'
import { StationCampaignContext } from '../../DashboardCampaign'

const headers = ['name']

const TableCampaignObjectives = () => {
    const {
        isEditMode,
        campaign,
        campaignObjectives, setCampaignObjectives,
        campaignPlannings, setCampaignPlannings,
        campaignPlanningsExceptions, setCampaignPlanningsExceptions,
    } = useContext(StationCampaignContext)

    const objectiveList = useCampaignObjectives(campaign.campaignType)

    const [selectedObjectiveId, setSelectedObjectiveId] = useState()
    const {
        value: isConfirmOpen,
        setTrue: onOpenConfirm,
        setFalse: onCloseConfirm,
    } = useBoolean(false)

    const countPlanning = objectiveId => campaignPlannings.reduce((nb, planning) => {
        if (includes(planning.objectivesPlan, objectiveId)
            || campaignPlanningsExceptions.some(({ planningId, objectivesToAddPlan, objectivesToDeletePlan }) => (
                planningId === planning.id && includes([...objectivesToAddPlan, ...objectivesToDeletePlan], objectiveId)
            ))
        ) return nb + 1
        return nb
    }, 0)

    const onDeleteObjective = objectiveId => {
        setCampaignPlannings(prev => removeObjectivesFromPlannings(prev, [objectiveId]))
        setCampaignPlanningsExceptions(prev => removeObjectivesFromExceptions(prev, [objectiveId]))
        setCampaignObjectives(prev => prev.filter(({ id }) => id !== objectiveId))
    }

    if (!hasValue(campaign.campaignType)) {
        return <NoDataPanel message={i18n.selectCampaignTypeFirst} />
    }

    const formattedObjectives = orderBy(campaignObjectives, 'objectiveCode').map(objective => ({
        name: objectiveList.find(({ code }) => code === objective.objectiveCode)?.name,

        id: objective.id,
        nbUsedInPlanning: countPlanning(objective.id),
    }))

    const nbUsedInPlanning = countPlanning(selectedObjectiveId)

    return (
        <>
            <NewTable
                rows={formattedObjectives}
                headers={headers}
                WrapperComponent={WrapperCardContent}
                lineActions={[{
                    icon: 'close',
                    onClick: ({ id, nbUsedInPlanning: nbPlannings }) => {
                        if (nbPlannings === 0) onDeleteObjective(id)
                        else {
                            setSelectedObjectiveId(id)
                            onOpenConfirm()
                        }
                    },
                    displayed: isEditMode,
                }]}
            />
            <ConfirmModal
                isOpen={isConfirmOpen}
                title={i18n.deletingConfirmation}
                subTitle={nbUsedInPlanning > 1
                    ? template(i18n.objectiveUsedInplannings)({ nb: nbUsedInPlanning })
                    : i18n.objectiveUsedInplanning
                }
                onValidate={() => {
                    onDeleteObjective(selectedObjectiveId)
                    onCloseConfirm()
                }}
                onClose={onCloseConfirm}
            />
        </>
    )
}

export default TableCampaignObjectives
